let subscribeSend = document.querySelector('.subscribe-send')

if(subscribeSend) {
    subscribeSend.addEventListener('click', (e) => {
        e.preventDefault()

        let form = document.querySelector('.subscribe-form')
        let nameField = form.querySelector('.name')
        let emailField = form.querySelector('.email')

        if(!emailField.check() && !nameField.check()) {
            let name = nameField.value
            let email = emailField.value
            let product = window.product
            let data = {name, email, product}

            requestAxios('subscribeToProduct', data, () => {
                let popup = document.querySelector('.subscribe-popup')
                window.subscribes.push(product)

                popup.hide()

                add_notif({
                    title: 'Подписка',
                    text: 'Вам на почту будет выслано уведомление при поступлении',
                    icon: 'success',
                    timeout: 5000
                })
            })
        }
    })
}